import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import WorldMap from './dataViz/Worldmap'
import fetchData from '../../service/apiService'
import ForegroundLoader from '../../common/components/Loader/ForegroundLoader'
import {
  clone,
  formatNumber,
  getEndpointFromConfig,
} from '../../common/utils/helper'
import { endpointLabels, pillarNames } from '../../common/utils/enum'

const PillarWorldmapWrapper = ({
  countryProfileURLAuthor,
  countryProfileURLPublish,
  countryCodes,
}) => {
  const boundaries = useSelector((state) => state.common['countryBoundaries'])
  const { endpointList, environment, apiKeyIncluded, apiKeyName, apiKeyValue } =
    useSelector((state) => state.common)
  const { selectedPillar, countryList } = useSelector(
    (state) => state.dataHomepage
  )

  const [features, setFeatures] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchPillarData = async () => {
      try {
        setIsLoading(true)
        const url = getEndpointFromConfig(
          endpointList,
          endpointLabels.OverallPillarScores
        )?.apiEndpoint
        let headers = undefined
        if (apiKeyIncluded === 'true') {
          headers = {
            [apiKeyName]: apiKeyValue,
          }
        }
        const response = await fetchData(url, 'GET', null, headers)
        if (response && response.length > 0) {
          const data = [...response]
          let initialFeatures = clone(boundaries?.features)
          initialFeatures.forEach((feature) => {
            let countryData = data.find((pillar) =>
              // handle different codes for Romania, Timor-Leste and West Bank and Gaza for maps API
              {
                if (countryCodes && countryCodes.length > 0) {
                  const codeObj = countryCodes.find(
                    (item) =>
                      item.breadyAPICode.toLowerCase() ===
                      pillar.EconomyCode.toLowerCase()
                  )
                  if (codeObj) {
                    return (
                      codeObj.mapAPICode.toLowerCase() ===
                      feature.properties.iso3.toLowerCase()
                    )
                  } else {
                    return (
                      pillar.EconomyCode.toLowerCase() ===
                      feature.properties.iso3.toLowerCase()
                    )
                  }
                } else {
                  return (
                    pillar.EconomyCode.toLowerCase() ===
                    feature.properties.iso3.toLowerCase()
                  )
                }
              }
            )
            if (countryData) {
              let value = countryData[selectedPillar]
              feature.properties.value = formatNumber(value)
              feature.properties.country_na = countryData.Economy
              feature.properties.iso3 = countryData.EconomyCode
            }
          })
          setFeatures(initialFeatures)
        }
      } catch (error) {
        console.error('Error fetching overall pillar scores:', error)
      } finally {
        setIsLoading(false)
      }
    }
    if (
      selectedPillar &&
      Object.keys(boundaries).length > 0 &&
      apiKeyIncluded
    ) {
      fetchPillarData()
    } else if (Object.keys(boundaries).length > 0) {
      setFeatures(boundaries.features)
    }
  }, [selectedPillar, endpointList, boundaries, apiKeyIncluded])

  const handleTooltipClick = (country) => {
    const countryData = countryList.find(
      (item) => item.id.toLowerCase() === country.toLowerCase()
    )
    let redirectURL = ''
    if (environment === 'author') {
      redirectURL = `${countryProfileURLAuthor}.${countryData.url}.html`
    } else {
      redirectURL = `${countryProfileURLPublish}/${countryData.url}`
    }
    window.open(redirectURL, '_self')
  }

  return (
    <>
      {isLoading && <ForegroundLoader />}
      <WorldMap
        features={features}
        handleTooltipClick={handleTooltipClick}
        selectedTab="pillar"
        selectedValue={
          pillarNames.find(
            (item) =>
              item.datapointName.toLowerCase() === selectedPillar.toLowerCase()
          )?.name
        }
      />
    </>
  )
}
export default PillarWorldmapWrapper
